<div class="container-div min-w-6xl">
  <mat-card class="p-0" [class.pb-xxs]="requestInFlight$ | async">
    <mat-card-content>
      @if ((requestInFlight$ | async) === false) {
      <div>
        @if (hasCvqRequestError) {
        <cui-notification-banner
          [actionable]="true"
          (action)="refreshCVQs()"
          actionButtonText="Try Again"
          type="error"
        >
          {{ defaultErrorMessage }}
        </cui-notification-banner>
        } @if ( !hasCvqRequestError && (this.dataSource$ | async) &&
        (this.dataSource$ | async)!.length == 0 ) {
        <div class="py-bl-2">
          <div class="flex items-center">
            <p class="pl-xxs">There are currently no CVQs.</p>
          </div>
        </div>
        }
      </div>
      } @if ( (this.dataSource$ | async) && (this.dataSource$ | async)!.length
      !== 0 ) {
      <div data-pgr-id="cvqDisplay">
        <mat-divider class="actions-bar-divider"></mat-divider>
        <div>
          <mat-card class="p-0 cvq-display-card">
            <mat-card-content>
              <cla-list-component
                [dataSource]="dataSource$ | async"
              ></cla-list-component>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
